import styled from "styled-components";

export const Flex = styled.div`
    align-items: center;
    flex-wrap: wrap;
    flex-direction: row;
    display: flex;
`;

export const FlexSpaceBetween = styled(Flex)`
    justify-content: space-between;
`;
